import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ExternalAccessGuard implements CanActivate, CanMatch {

  constructor(private router: Router) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    // Ex.: ['chamados','analyst-view']
    const path = segments.map(s => s.path).join('/');
    const isAnalystView = path.endsWith('analyst-view');
    const params = new URLSearchParams(window.location.search);
    const authKey = params.get('authKey') || '';
    const callCode = params.get('callcode') || '';
    const idClient = params.get('idclient') || '';

    if (isAnalystView && this.isValidAuthKey(authKey)) {
      this.enableExternalMode({ authKey, callCode, idClient });
      return true; // permite carregar o módulo/rota sem login
    }

    return true; // segue fluxo normal para outras rotas
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const isAnalystView = state.url.includes('/chamados/analyst-view');
    const params = new URLSearchParams(window.location.search);
    const authKey = params.get('authKey') || '';
    const callCode = params.get('callcode') || '';
    const idClient = params.get('idclient') || '';

    if (isAnalystView && this.isValidAuthKey(authKey)) {
      this.enableExternalMode({ authKey, callCode, idClient });
      return true;
    }

    return true;
  }

  private isValidAuthKey(authKey: string): boolean {
    return !!authKey && authKey.length >= 10;
  }

  private enableExternalMode({ authKey, callCode, idClient }: { authKey: string; callCode: string; idClient: string }) {
    localStorage.setItem('isExternalAccess', 'true');
    if (callCode) localStorage.setItem('externalCallCode', callCode);
    if (idClient) localStorage.setItem('externalIdClient', idClient);
    // token fake para evitar interceptores que exigem Authorization
    const token = btoa(JSON.stringify({ isExternal: true, sub: idClient, callCode, exp: Date.now() + 2 * 60 * 60 * 1000 }));
    localStorage.setItem('externalToken', token);
  }
}
